import { Swiper, Navigation, Pagination, Thumbs, Controller } from 'swiper';
import elementExists  from "../core/utils/element-exists";
const RelatedArticles = function(){
    const containers = document.querySelectorAll( "[related-articles]");
    if( elementExists( containers, true )){
        containers.forEach( container => {
            const data = container.dataset;
            const url = data.url.replace(  'tags'  , data.tags  );
            const swiperWrapper = container.querySelector( '.swiper-wrapper');
            const swiperContainer = container.querySelector( '.swiper');
            fetch( url )
            .then( res => {
                if( res.ok ){
                    return res.text();
                }
                return false;
            })
            .then( text => {
                if( text ){
                    swiperWrapper.innerHTML = text;
                    container.classList.remove( 'd-none');
                }else{
                    container.parentNode.removeChild( container )
                }
            })
        });
    }
}
export default RelatedArticles;

